// The mismatch hint waits until the user starts typing the confirmation.
export const getPasswordConfirmationState = (password: string, confirmation: string) => ({
    isMismatchVisible: confirmation.length > 0 && password !== confirmation,
    isConfirmed: password.length > 0 && password === confirmation,
})
